import { useState, useCallback } from "react";
import axios from "axios";

/**
 * Reusable hook for AI-powered document formatting.
 * Calls the backend POST /api/ai/format-document endpoint which runs
 * Xenova/flan-t5-small on the server — no browser-side model loading.
 *
 * @param {string} context  Optional document type hint (e.g. "authorization_permit")
 */
const useAILetterFormatter = (context = "") => {
  const [isFormatting, setIsFormatting] = useState(false);

  const formatLetter = useCallback(
    async (htmlContent, userPrompt = "") => {
      setIsFormatting(true);
      try {
        const { data } = await axios.post("/api/ai/format-document", {
          content: htmlContent,
          userPrompt,
          context,
        });
        return data.formattedContent;
      } finally {
        setIsFormatting(false);
      }
    },
    [context]
  );

  return { formatLetter, isFormatting };
};

export default useAILetterFormatter;
